export const RYLAK_COMMON_PUBLIC_FOLDER_PATH = "/rylak-common";
export const MAINTENANCE_ACTIVE = false;

export const INGRID_IFRAME_ID = "ingrid-returns-iframe";
export const INGRID_IFRAME_MODAL_APP_ID = "ingrid-returns-modal-iframe";

export const IFRAME_ACTIONS = {
    // Internal API
    INITIALIZED: "initialized",
    UPDATE_BRAND_DATA: "update-brand-data",

    // Relay between iframes
    TO_MODAL_IFRAME_LANGUAGE_CHANGED: "to-modal-iframe-language-changed",
    TO_MODAL_IFRAME_OPEN_IFRAME_PRODUCT_MODAL: "to-modal-iframe-open-iframe-modal",
    TO_MAIN_IFRAME_SAVE_PRODUCT_CHOICE: "to-main-iframe-save-product-choice",

    // Public API
    SET_LANGUAGE_CODE: "ingrid-returns-iframe-set-language-code",
    APP_SIZE_CHANGE: "ingrid-returns-iframe-size-change",
    OPEN_MODAL: "ingrid-returns-iframe-open-modal",
    CLOSE_MODAL: "ingrid-returns-iframe-close-modal",
    PAGE_CHANGE: "ingrid-returns-iframe-page-change",

    SET_LANGUAGE_CODE_OLD: "setLanguageCode", // deprecated
    APP_SIZE_CHANGE_OLD: "ingrid-returns-iframe-data", // deprecated
};

export const INGRID_SUPPORT_EMAIL = "support@ingrid.com";

export const EMAIL_VALIDATION_REGEX = /(.+)@(.+){1,}\.(.+){2,}/;

export const WEEK_DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const DARK_BROWN = "black";
const MID_BROWN = "#343a40";
const BROWN = "#868e96";
const LIGHT_BROWN = "#ced4da";
const PALE_YELLOW = "#e9ecef";
const BLACK = "#212529";

// Secondary colors
const DUSTY_PINK = "#e9ecef";
const GREY = "#aab4aa";
export const COLORS = {
    MAIN_COLOR: DARK_BROWN,
    SECONDARY_COLOR: DUSTY_PINK,
    BACKGROUND: "#F4F6F8",
    SUCCESS: "#4eb500",
    LINK_SECONDARY_COLOR: BROWN,
    INFO: "#1971c2",
    CHANGES: "#1971c2",
    ACTION: "#228be6",
    EXCHANGE: "#758FF4",
    RESALE: "#5ED05C",
    GIFT_CARD: "#FF922B",
    RETURN: "#2fcdba",
    ORDER: MID_BROWN,
    RETURN_OUTSIDE_TURNR: "#219789",
    EXTERNAL_SHIPMENT: "#868e96",
    COMPLAINT: "#FF6767",
    DENY: "#FF6767",
    WARNING: "#f08c00",
    GRAY: "#e4e4e4",
    PICKUP: "#FCC419",
    TRANSPORT: "#CC5DE8",
    C2C: "#cc5de8",
    STARTUP_GUIDE: "#9c36b5",
    SLIGHTLY_WEAK_TEXT: "#515559",
    WEAK_TEXT: "#868e96",
    VERY_WEAK_TEXT: "#aab4aa",
    BLACK: BLACK,
    DARK_BROWN: DARK_BROWN,
    BROWN: BROWN,
    MID_BROWN: MID_BROWN,
    LIGHT_BROWN: LIGHT_BROWN,
    PALE_YELLOW: PALE_YELLOW,
    DUSTY_PINK: DUSTY_PINK,
    GREY: GREY,
    LIGHT_BACKGROUND_BLUE: "#edf2ff",
    LIGHT_BACKGROUND_GREEN: "#d3f9d8",
    LIGHT_BACKGROUND_RED: "#ffe3e3",
    DISABLED_INPUT: GREY,
    LINK: "#1c7ed6",
    ERROR: "#FB5A32",
    ORANGE: {
        main: "#ff8825",
        light: "#ffd8a8",
        extraLight: "#fff3e6",
        dark: "#ea7819",
        contrastText: "#ffffff",
    },
    GREEN: {
        main: "#20c997",
        light: "#96f2d7",
        extraLight: "#e1fff6",
        dark: "#12b886",
        contrastText: "#ffffff",
    },
    BLUE: {
        main: "#4dabf7",
        light: "#a5d8ff",
        extraLight: "#e5f0ff",
        dark: "#228be6",
        contrastText: "#ffffff",
    },
    PURPLE: {
        main: "#9775fa",
        light: "#d0bfff",
        extraLight: "#f5f2ff",
        dark: "#7950f2",
        contrastText: "#ffffff",
    },
};

export const RASPUTIN_COLOR_TYPES = {
    RED: COLORS.ERROR,
    ORANGE: COLORS.ORANGE.main,
    GREEN: COLORS.SUCCESS,
};

export const RETURN_STATUS_EVENTS = {
    RETURN_CREATED: "RETURN_CREATED", // ORDER_BOOKED
    COMPLAINT_PENDING: "COMPLAINT_PENDING", //COMPLAINT_CHECK
    COMPLAINT_DENIED: "COMPLAINT_DENIED",
    BOOKING_SHIPMENTS: "BOOKING_SHIPMENTS",
    PACK_ITEMS_LOCKER: "PACK_ITEMS_LOCKER", // BOOK_LOCKER
    PACK_ITEMS_PRINT_LABEL: "PACK_ITEMS_PRINT_LABEL",
    PACK_ITEMS_RETURN_SLIP: "PACK_ITEMS_RETURN_SLIP",
    PACK_ITEMS_CUSTOMER_BOOKS_SHIPMENT: "PACK_ITEMS_CUSTOMER_BOOKS_SHIPMENT",
    PACK_ITEMS_PICKUP: "PACK_ITEMS_PICKUP", // PACK_ITEMS_NO_BAG_DELIVERY,
    PACK_ITEMS_RETURN_IN_STORE: "PACK_ITEMS_RETURN_IN_STORE",
    RETURN_IN_TRANSIT: "RETURN_IN_TRANSIT", // ITEMS_RETRIEVED
    QUALITY_CONTROL_PENDING: "QUALITY_CONTROL_PENDING", // QUALITY_CONTROL_PENDING
    RETURN_COMPLETED: "RETURN_COMPLETED", // REFUNDED
    RETURN_CANCELLED: "RETURN_CANCELLED", // ORDER_CANCELLED
};

export const COOKIES_POLICIES = {
    ENABLED: "ENABLED",
    DISABLED: "DISABLED",
};

export const PRIVACY_POLICY_DEFAULT_URL = "https://www.ingrid.com/privacy-policy";

export const BRAND_ROUNDED_STYLE_TYPES = {
    SHARP: "SHARP",
    SLIGHTLY_ROUNDED: "SLIGHTLY_ROUNDED",
    ROUNDED: "ROUNDED",
    VERY_ROUNDED: "VERY_ROUNDED",
    FULLY_ROUNDED: "FULLY_ROUNDED",
};

export const PRODUCT_POLICIES = {
    ALWAYS_ACCEPT: "ALWAYS_ACCEPT",
    ALWAYS_REJECT: "ALWAYS_REJECT",
};

export const QUERY_PARAMETER_MODAL_IFRAME_ACTIVE = "modal-iframe-active";

//TODO remove RETURN_REASON_TYPES duplicate in Backoffice
export const RETURN_REASON_TYPES = {
    SIMPLE: "SIMPLE",
    MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
    CHECKBOX: "CHECKBOX",
    FREE_TEXT: "FREE_TEXT",
};

export const EXCHANGE_PROPERTY_PICKER_TYPES = {
    FORCE_DROPDOWNS: "FORCE_DROPDOWNS",
    DEFAULT: "DEFAULT",
};

//todo This is a duplicate from return portal. Solve this :)
export const LANGUAGE_EN = "EN";
export const LANGUAGE_EN_TR = "EN_TR";
export const LANGUAGE_SV = "SV";
export const LANGUAGE_DE = "DE";
export const LANGUAGE_NO = "NO";
export const LANGUAGE_FR = "FR";
export const LANGUAGE_ES = "ES";
export const LANGUAGE_OPTIONS = [
    {
        label: "English",
        value: LANGUAGE_EN,
        icon: "/icons/country-flags/gb.svg",
    },
    {
        label: "Norsk",
        value: LANGUAGE_NO,
        icon: "/icons/country-flags/no.svg",
    },
    {
        label: "Svenska",
        value: LANGUAGE_SV,
        icon: "/icons/country-flags/se.svg",
    },
    {
        label: "Deutsch",
        value: LANGUAGE_DE,
        icon: "/icons/country-flags/de.svg",
    },
    {
        label: "Français",
        value: LANGUAGE_FR,
        icon: "/icons/country-flags/fr.svg",
    },
    {
        label: "Español",
        value: LANGUAGE_ES,
        icon: "/icons/country-flags/es.svg",
    },
    {
        label: "български",
        value: "BG",
        icon: "/icons/country-flags/bg.svg",
    },
    {
        label: "Hrvatski",
        value: "HR",
        icon: "/icons/country-flags/hr.svg",
    },
    {
        label: "Čeština",
        value: "CS",
        icon: "/icons/country-flags/cz.svg",
    },
    {
        label: "Dansk",
        value: "DA",
        icon: "/icons/country-flags/dk.svg",
    },
    {
        label: "Nederlands",
        value: "NL",
        icon: "/icons/country-flags/nl.svg",
    },
    {
        label: "Eesti keel",
        value: "ET",
        icon: "/icons/country-flags/ee.svg",
    },
    {
        label: "Suomi",
        value: "FI",
        icon: "/icons/country-flags/fi.svg",
    },
    {
        label: "Eλληνικά",
        value: "EL",
        icon: "/icons/country-flags/gr.svg",
    },
    {
        label: "Magyar",
        value: "HU",
        icon: "/icons/country-flags/hu.svg",
    },
    {
        label: "Gaeilge",
        value: "GA",
        icon: "/icons/country-flags/ie.svg",
    },
    {
        label: "Italiano",
        value: "IT",
        icon: "/icons/country-flags/it.svg",
    },
    {
        label: "Latviešu valoda",
        value: "LV",
        icon: "/icons/country-flags/lv.svg",
    },
    {
        label: "Lietuvių kalba",
        value: "LT",
        icon: "/icons/country-flags/lt.svg",
    },
    {
        label: "Malti",
        value: "MT",
        icon: "/icons/country-flags/mt.svg",
    },
    {
        label: "Polski",
        value: "PL",
        icon: "/icons/country-flags/pl.svg",
    },
    {
        label: "Português",
        value: "PT",
        icon: "/icons/country-flags/pt.svg",
    },
    {
        label: "Român",
        value: "RO",
        icon: "/icons/country-flags/ro.svg",
    },
    {
        label: "Slovak",
        value: "SK",
        icon: "/icons/country-flags/sk.svg",
    },
    {
        label: "Slovenčina",
        value: "SL",
        icon: "/icons/country-flags/si.svg",
    },
    {
        label: "中文",
        value: "ZH",
        icon: "/icons/country-flags/cn.svg",
    },
    {
        label: "日本語",
        value: "JA",
        icon: "/icons/country-flags/jp.svg",
    },
    {
        label: "한국어",
        value: "KOR",
        icon: "/icons/country-flags/kr.svg",
    },
    {
        label: "हिन्दी",
        value: "HI",
        icon: "/icons/country-flags/in.svg",
    },
    {
        label: "Bahasa Indonesia",
        value: "ID",
        icon: "/icons/country-flags/id.svg",
    },
    {
        label: "বাংলা",
        value: "BEN",
        icon: "/icons/country-flags/bd.svg",
    },
    {
        label: "Tiếng việt",
        value: "VIE",
        icon: "/icons/country-flags/vn.svg",
    },
    {
        label: "Kiswahili",
        value: "SW",
        icon: "/icons/country-flags/ke.svg",
    },
    {
        label: "Nederlands (België)",
        value: "NL_BE",
        icon: "/icons/country-flags/be.svg",
    },
    {
        label: "Français (Belgique)",
        value: "FR_BE",
        icon: "/icons/country-flags/be.svg",
    },
    {
        label: "Deutsch (Österreich)",
        value: "DE_AT",
        icon: "/icons/country-flags/at.svg",
    },
];
